import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios"; 
import { CALL_PPOR_API, MIDDLE_WARE_BASE_URL_v1 } from "../../../utils/CONSTANTS";

// Define initial state
const initialState = {
  moodMeterFAQState: "pending", 
  FAQData: [], 
  moodMeterUpdate: "", 
};

// Create an async thunk to call the API
export const moodMeterFAQ = createAsyncThunk(
  "get/moodMeterFAQ",
  async (data: any) => {
    const response = axios.postStrReqNoLoader(
      MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API() ,
      data
    );
    return response;
  }
);

// Create slice with actions and reducers
const moodMeterFAQSlice = createSlice({
  name: "moodMeterFAQ",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(moodMeterFAQ.pending, (state) => {
        state.moodMeterFAQState = "pending"; 
      })
      .addCase(moodMeterFAQ.fulfilled, (state, action) => {
        let tempRes = action.payload?.data?.response;
        if (typeof tempRes === "string") {
          tempRes = JSON.parse(tempRes); 
        }

        state.moodMeterFAQState = "fulfilled"; 
        state.FAQData = tempRes?.response?.response?.row || []; 
      })
      .addCase(moodMeterFAQ.rejected, (state) => {
        state.moodMeterFAQState = "failed"; 
      }),
});

// Selector to get the data from the store
export const faqListDetails = (state: any) => state.moodMeterFAQ;

// Export the reducer for the slice
export default moodMeterFAQSlice.reducer;
